import React, { useState } from 'react'
import Select from "react-select"
import { Dropdown, Menu, Select as AntSelect } from 'antd'
import { useParams } from 'react-router-dom'

import { AiOutlineDown } from 'react-icons/ai'

import { useListData, usePet, useToggle } from '../../modules'

import Receive from '../../components/reusable/receive'
import NewSaleItem from '../../components/drawers/newSaleItem'
import AddVariant from '../../components/modals/addVariant'
import SaleItem from '../../components/modals/saleItem'
import SaleItemPrices from '../../components/modals/saleItemPrices'
import EditSaleItem from '../../components/drawers/editSaleItem'
import EditLinkedSaleItem from '../../components/drawers/editLinkedSaleItem'

const { Option } = AntSelect

const SaleItems = () => {
    const { id } = useParams()

    const [string, setString] = useState('')
    const [siType, setSiType] = useState(null)
    const [category, setCategory] = useState()
    const [selected, setSelected] = useState()
    const [accounts, setAccounts] = useState([])

    const [linked, toggleLinked] = useToggle()
    const [pricesModal, togglePricesModal] = useToggle()
    const [editSaleItem, toggleEditSaleItem] = useToggle()
    const [saleItemModal, toggleSaleItemModal] = useToggle()
    const [addVariantModal, toggleAddVariantModal] = useToggle()
    const [newSaleItemModal, toggleNewSaleItemModal] = useToggle()

    const [
        { loading: itemsLoading, error: itemsError, fetch: fetchItems }, 
        { list: saleItems }, 
        { navigate, Paginate, page, limit }
    ] = useListData('saleItems', {
        string,
        includeUnavailable: true,
        category: category?.label
    }, { notify: true }, 'items')

    useListData('accounts', { string, types: ['Expenses', 'Cost of Goods Sold'] }, { notify: true, manual: false }, 'accounts', 100, ({ accounts: data }) => {
        let obj = {}

        data.forEach(acc => {
            if (!obj[acc.type])
                obj[acc.type] = []

            obj[acc.type].push({
                label: acc.name,
                value: acc._id
            })
        })

        let final = []
        for (let typ in obj) {
            final.push({
                label: typ,
                options: obj[typ]
            })
        }

        setAccounts(final)
    })

    const [{ loading: catsLoading, error: catsError, data: categories = [] }, fetchCats] = usePet('saleItemCategories', null, { notify: true })
    
    const onComplete = ({ data }, notif, ops) => {
        notif(`Item is now ${ data.unavailable ? 'unavailable' : 'available' }`, ops('success'))
        fetchItems()
    }

    const [{ data: lists = [] }] = usePet('priceLists', { limit: 100 }, { notify: true, callback: async () => null })

    const [, toggleItemAvailability] = usePet('toggleSaleItemAvailability', {
        id: selected?._id
    }, { notify: true, callback: onComplete, manual: true })

    const addVariant = itm => {
        setSelected(itm)
        toggleAddVariantModal()
    }

    const viewSaleItem = itm => {
        setSelected({
            ...itm,
            account: { label: itm.account.name, value: itm.account._id }
        })
        // toggleSaleItemModal()
        if (itm.variants.length > 0)
            toggleEditSaleItem()
        else
            toggleLinked()
    }

    const viewSaleItemPrices = itm => {
        setSelected(itm)
        togglePricesModal()
    }
    
    const toggleAvailability = itm => {
        setSelected(itm)
        toggleItemAvailability()
    }

    const refetch = () => {
        fetchItems()
        fetchCats()
        navigate(1)
    }

    const changeCategory = val => {
        setCategory(val)
        refetch()
    }

    const search = str => {
        setString(str)
        if (str?.trim().length > 2 || str.length === 0)
            refetch()
    }

    const toggleNew = typ => {
        setSiType(typ)
        toggleNewSaleItemModal()
    }

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            {
                newSaleItemModal &&
                <NewSaleItem
                    type={ siType }
                    onPerform={ refetch }
                    toggle={toggleNewSaleItemModal}
                    visible={newSaleItemModal} />
            }
            {
                saleItemModal &&
                <SaleItem
                    item={ selected }
                    onPerform={ refetch }
                    toggle={toggleSaleItemModal}
                    visible={saleItemModal} />
            }
            {
                linked &&
                <EditLinkedSaleItem
                    linked={ false }
                    itm={selected}
                    type={ selected?.type }
                    priceLists={lists?.lists ?? []}
                    visible={linked}
                    accounts={accounts}
                    onComplete={ refetch }
                    toggle={toggleLinked} />
            }
            {
                editSaleItem &&
                <EditSaleItem
                    item={ selected }
                    onPerform={ refetch } 
                    toggle={ toggleEditSaleItem }
                    visible={ editSaleItem }/>
            }
            {
                addVariantModal &&
                <AddVariant
                    onPerform={ refetch }
                    toggle={ toggleAddVariantModal }
                    visible={ addVariantModal }
                    item={ selected }/>
            }
            {
                pricesModal &&
                <SaleItemPrices
                    onPerform={ refetch }
                    toggle={ togglePricesModal }
                    visible={ pricesModal }
                    item={ selected }/>
            }
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
                {/* <ul className="flex flex-wrap justify-center sm:justify-start mb-8 sm:mb-0 -space-x-3 -ml-px" /> */}
                <input
                    onChange={e => search(e.target.value)}
                    className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-inv-item"
                    type="text"
                    placeholder="Search Sale Items" />
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                    {/* Filter button */}
                    {/* <FilterButton
                        options={['prepared', 'sale items', 'service']} /> */}
                    <Dropdown
                        overlay={
                            <Menu>
                                <Menu.Item onClick={ () => toggleNew('Sale Item') }>Sale Item</Menu.Item>
                                <Menu.Item onClick={ () => toggleNew('Prepared Item') }>Prepared Item</Menu.Item>
                                <Menu.Item onClick={ () => toggleNew('Service') }>Service</Menu.Item>
                            </Menu>
                        }>
                        <button className="btn hisani-btn-green-light text-white">
                            <svg className="w-4 h-4 fill-current opacity-50 flex-shrink-0" viewBox="0 0 16 16">
                                <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                            </svg>
                            <span className="hidden xs:block ml-2">New Item/Service</span>
                        </button>
                    </Dropdown>
                </div>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <Receive
                    error={itemsError}
                    loading={itemsLoading}
                    progress>
                    <>
                        <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                            <h2 className="font-semibold text-gray-800">Sale Items & Services</h2>
                            <Receive
                                error={catsError}
                                loading={catsLoading}
                                progress>
                                <Select
                                    isClearable
                                    value={ category }
                                    onChange={ changeCategory }
                                    styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                                    options={categories?.map(category => ({ label: category, value: category }))}
                                    placeholder="Category" />
                            </Receive>
                        </header>
                        <div className="p-3">
                            <div className="overflow-x-auto">
                                <Receive
                                    error={itemsError}
                                    loading={itemsLoading}
                                    progress>
                                    {
                                        saleItems.length > 0 ?
                                            <table className="table-auto w-full">
                                                {/* Table header */}
                                                <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                                    <tr>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-center">No</div>
                                                        </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-left">Item</div>
                                                        </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-center">Category</div>
                                                        </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-center">Price</div>
                                                        </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-center">Status</div>
                                                        </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-center">Opened On</div>
                                                        </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-center"></div>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                {/* Table body */}
                                                <tbody className="text-sm font-medium divide-y divide-gray-100">
                                                    {
                                                        saleItems.map((item, key) =>
                                                            <tr>
                                                                <td className="p-2">
                                                                    <div className="text-center">{ ((page - 1) * limit) + (key + 1) }.</div>
                                                                </td>
                                                                <td className="p-2">
                                                                    <div className="">{item.name}</div>
                                                                    <p className="text-gray-500 text-xs italic">{item.type}</p>
                                                                </td>
                                                                <td className="p-2">
                                                                    <div className="text-center">{item.category}</div>
                                                                </td>
                                                                <td className="p-2">
                                                                    <div className="text-center">{item.price ? `Ksh. ${item.price}` : `${item.variants.length} variants`}</div>
                                                                </td>
                                                                <td className="p-2">
                                                                    <div className={ `text-center ${item.active ? 'text-green-500' : 'text-gray-500' }` }>{ item.active ? 'Available' : 'Unavailable' }</div>
                                                                </td>
                                                                <td className="p-2 text-center">
                                                                    <Dropdown
                                                                        overlay={
                                                                            <Menu>
                                                                                <Menu.Item onClick={ () => viewSaleItem(item) }>View</Menu.Item>
                                                                                { item?.type !== 'variant' && <Menu.Item onClick={ () => addVariant(item) }>Add Variant</Menu.Item> }
                                                                                <Menu.Item onClick={ () => viewSaleItemPrices(item) }>View Pricing</Menu.Item>
                                                                                <Menu.Item onClick={ () => toggleAvailability(item) }>Make { item.active ? 'Unavailable' : 'Available' }</Menu.Item>
                                                                            </Menu>
                                                                        }>
                                                                        <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                                    </Dropdown>
                                                                </td>
                                                            </tr>
                                                        )
                                                    }
                                                </tbody>
                                            </table>
                                        :
                                            <div className="flex font-semibold text-md justify-center items-center">
                                                <h2>Please click above to add some items</h2>
                                            </div>
                                    }
                                </Receive>
                                {Paginate}
                            </div>
                        </div>
                    </>
                </Receive>
            </div>
        </div>
    )
}

export default SaleItems